import MyAxios from "@/utilize/MyAxios";
import { useMutation } from "@tanstack/react-query";

type TPayload = {
  organizationId: string;
  file: File;
};

const useUpdateLogo = () => {
  return useMutation({
    mutationFn: async ({ organizationId, file }: TPayload) => {
      const formData = new FormData();
      formData.append("logo", file);

      return MyAxios.put(`/organizations/${organizationId}/logo`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    },
  });
};

export default useUpdateLogo;
